// src/Chat/ChatLayout.jsx
import React, { useEffect } from 'react';
import Sidebar from './Sidebar';
import ChatWindow from './ChatWindow';
import { Box, useMediaQuery } from '@mui/material';
import { useChatContext } from '../context/SignamRContext';

const ChatLayout = ({ activeChat, setActiveChat }) => {
  const { setConversationId } = useChatContext();
  const isMobile = true; // useMediaQuery('(max-width: 600px)');
  const onBack = () => {
    // TESTIRANJE se poništava čim korisnik napusti chat
    if (String(localStorage.getItem('oznaka')).toUpperCase() === 'TESTIRANJE') {
      localStorage.setItem('oznaka', 'null');
    }
    setActiveChat(null);
    setConversationId(null);
  };
  return (
    <Box display="flex" bgcolor="#f4f6fa">
      {!activeChat || !isMobile ? (
        <Sidebar isMobile={isMobile} onSelectChat={setActiveChat} />
      ) : null}
      {activeChat ? (
        <ChatWindow
          isMobile={isMobile}
          onBack={() => onBack()}
          activeChat={activeChat}
          setActiveChat={setActiveChat}
        />
      ) : null}
    </Box>
  );
};

export default ChatLayout;
